/* eslint-disable no-param-reassign */
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '~/store/actions';
import api from '~/services';
import log from '~/helpers/log';

export default function useUpdateContact(values = false) {
  const [updateContact, setUpdateContactValue] = useState(values);
  const [errorUpdate, setError] = useState(null);
  const dispatch = useDispatch();

  async function setUpdateContact(id, data) {
    try {
      const contact = await api.contacts.patch.updateContact(id, data);
      if (contact.data.error) {
        setUpdateContactValue(false);
        setError(contact.data.error.message);
      } else {
        if (!data.changedTab) {
          if (data.personal) {
            dispatch(actions.checkNewContacts('Personal', false, true, id));
          } else {
            dispatch(actions.checkNewContacts('All', false, true, id));
          }
        } else if (data.personal) {
          dispatch(actions.checkNewContacts('Personal', false, true, id));
          dispatch(actions.deleteContact('All', id));
        } else {
          dispatch(actions.checkNewContacts('All', false, true, id));
          dispatch(actions.deleteContact('Personal', id));
        }
        setUpdateContactValue(true);
        setError(null);
      }
    } catch (err) {
      log.error('Failed to update contact details.', err);
    }
  }

  return [{ updateContact, errorUpdate }, setUpdateContact];
}
